import { TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  GoldBarParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C03HeadlineWithOptionalCTAProps = RenderingProps<
  C03HeadlineWithOptionalCTAFields,
  C03HeadlineWithOptionalCTAParams
>;

export type C03HeadlineWithOptionalCTAFields = {
  Headline?: TextField;
};

export type C03HeadlineWithOptionalCTAParams = {
  HeadlineTag?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams &
  GoldBarParams;
